function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#fefefe}\r\n\t");

var _ref3 = /*#__PURE__*/React.createElement("filter", {
  id: "logo-glow"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  result: "offsetblur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#AFD139"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "offsetblur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(10 10)",
  filter: "url(#logo-glow)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#349348",
  fillRule: "evenodd",
  d: "M0 15v18c0 2.2 1.2 4.1 3.1 5.2l15.8 9c1.9 1.1 4.2 1.1 6.1 0l15.8-9a6.1 6.1 0 0 0 3.1-5.2V15c0-2.2-1.2-4.1-3.1-5.2L25 .8a6.05 6.05 0 0 0-6.1 0l-15.8 9A6.1 6.1 0 0 0 0 15",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#73ad43",
  fillRule: "evenodd",
  d: "M5.5 11.5l-4.2 15c-.5 1.8 0 3.7 1.4 5.1l11.2 11.1c1.3 1.3 3.3 1.9 5.2 1.4l15.4-4c1.8-.5 3.3-1.9 3.8-3.7l4.2-15.1c.5-1.8 0-3.7-1.4-5.1l-11.2-11a5.46 5.46 0 0 0-5.2-1.4l-15.4 4c-1.8.5-3.3 1.9-3.8 3.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#afd139",
  fillRule: "evenodd",
  d: "M20.1 39.7c-.8-.3-1.8-.6-2.8-.9-10.4-3.1-8.5-1.1-10.9-11.4S3.1 19.7 11 12.5 16.1 5.9 26.5 9c10.3 3.1 8.4 1.1 10.9 11.4 2.4 10.3 3.3 7.7-4.6 14.9-6.4 5.9-5.8 6.6-10.8 5",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2 18.4H7.8c-.2 0-.3.1-.3.3v.8c0 .2.1.3.3.3h1.8c.1 0 .1.1.1.2v8.5c0 .2.1.3.3.3h1c.2 0 .2-.1.2-.3V20c0-.1.1-.2.2-.2h1.8c.2 0 .3-.1.3-.3v-.8c0-.2-.1-.3-.3-.3",
  className: "st3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.1 24.1c0 .1 0 .2-.1.2h-2.8c-.1 0-.1-.1-.1-.2v-1c0-.4.1-.7.2-.9.2-.2.4-.3.8-.3h1c.4 0 .6.1.8.3.2.2.2.5.2.9v1zm-.9-3.6h-1.4c-.7 0-1.3.2-1.7.6s-.6 1-.6 1.8v3.2c0 .8.2 1.4.6 1.8.4.4 1 .7 1.7.7h3.4c.2 0 .3-.1.3-.3v-.8c0-.2-.1-.3-.3-.3H16c-.7 0-1.1-.4-1.1-1.2v-.7c0-.1.1-.2.2-.2h4.1c.2 0 .3-.1.3-.3v-2c0-.8-.2-1.4-.6-1.8-.4-.3-1-.5-1.7-.5z",
  className: "st3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.4 27.2c0 .1-.1.1-.2.1h-1.8a2 2 0 0 1-.9-.2c-.2-.2-.3-.5-.3-.8v-.5c0-.4.1-.6.3-.8.2-.2.5-.2.9-.2h1.8c.1 0 .2 0 .2.1v2.3zm.8-6c-.4-.4-1-.7-1.7-.7h-2.9c-.2 0-.3.1-.3.3v.8c0 .2.1.3.3.3h2.7c.7 0 1.1.4 1.1 1.2v.6h-2c-.8 0-1.4.2-1.9.6-.4.4-.7.9-.7 1.7v.6c0 .7.2 1.3.7 1.6.4.4 1.1.6 1.9.6h3.4V23c0-.8-.2-1.4-.6-1.8z",
  className: "st3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.3 20.5h-.5c-.3 0-.7.1-.9.2-.3.2-.5.4-.6.6h-.1v-.6c0-.2-.1-.3-.2-.3h-1c-.2 0-.2.1-.2.3v7.6c0 .2.1.3.2.3h.9c.2 0 .2-.1.2-.3v-5.1c0-1 .4-1.5 1.2-1.5h.9c.2 0 .2-.1.2-.3v-.8c.1 0 0-.1-.1-.1",
  className: "st3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29 20.5h-.5c-.3 0-.7.1-.9.2-.3.2-.5.4-.6.6h-.1v-.6c0-.2-.1-.3-.2-.3h-.9c-.2 0-.2.1-.2.3v7.6c0 .2.1.3.2.3h.9c.2 0 .2-.1.2-.3v-5.1c0-1 .4-1.5 1.2-1.5h.9c.2 0 .2-.1.2-.3v-.8c.1 0 0-.1-.2-.1",
  className: "st3"
}));

const SvgLogoWShadow = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 68",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoWShadow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-wShadow.db0fa402.svg";
export { ForwardRef as ReactComponent };